export default __webpack_public_path__ + "static/apple-store-white-button-8e5ce3d0f213642e7ef727f98a5fba70.svg";